<template>
  <page-listado>
    <page-header title="Campañas">
      <b-button variant="primary" size="sm" to="/campanias/crear">
        <v-icon name="plus" width="16" />
        Crear campaña
      </b-button>
    </page-header>
    <tabla-campanias :campanias="campanias" @eliminar="eliminar" />
  </page-listado>
</template>

<script>
import api from "@/services/campanias.js";
import TablaCampanias from "./TablaCampanias.vue";
export default {
  components: { TablaCampanias },
  data() {
    return {
      campanias: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return api.listar(this.$route.query).then((campanias) => {
        this.campanias = campanias;
      });
    },
    eliminar(id) {
      api.eliminar(id).then(() => {
        this.$messages.info("Campaña eliminada correctamente");
        this.listar();
      });
    },
  },
};
</script>
